import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { demoPatient, demoConsultation, demoDocument } from "../demo/demoData";

export default function DemoDocument() {
  return (
    <div className="min-h-screen bg-slate-100 p-4 sm:p-8">
      <div className="max-w-4xl mx-auto space-y-4">
        <p className="text-xs font-medium text-slate-500 text-center tracking-wide">
          Consulta ✔ → Documento → Empezar
        </p>
        <p className="text-sm text-slate-600 text-center max-w-2xl mx-auto">
          Este documento se genera automáticamente a partir de la consulta
        </p>
        <div className="flex justify-between items-center">
          <Badge className="bg-sky-100 text-sky-700 border-sky-200">Documento de demostracion</Badge>
        </div>

        <Card className="border-slate-200 shadow-md">
          <CardHeader className="border-b border-slate-100">
            <CardTitle className="text-xl text-slate-900">Documento clinico</CardTitle>
            <p className="text-sm text-slate-600">{demoDocument.medico}</p>
            <p className="text-sm text-slate-500">{demoDocument.clinica}</p>
          </CardHeader>
          <CardContent className="space-y-5 pt-5">
            <section>
              <h3 className="text-sm font-semibold text-slate-800 mb-1">Datos del paciente</h3>
              <p className="text-sm text-slate-700">
                {demoPatient.nombre} · {demoPatient.edad} anos · {demoPatient.sexo}
              </p>
            </section>

            <section>
              <h3 className="text-sm font-semibold text-slate-800 mb-1">Motivo</h3>
              <p className="text-sm text-slate-700">{demoConsultation.motivo}</p>
            </section>

            <section>
              <h3 className="text-sm font-semibold text-slate-800 mb-1">Escalas resumidas</h3>
              <div className="grid sm:grid-cols-2 gap-2">
                {demoConsultation.escalas.map((s) => (
                  <p key={s.nombre} className="text-sm text-slate-700">
                    <strong>{s.nombre}:</strong> {s.valor} - {s.interpretacion}
                  </p>
                ))}
              </div>
            </section>

            <div className="grid gap-3 sm:grid-cols-1">
              <div className="rounded-xl border-2 border-sky-200 bg-sky-50/80 p-4 ring-1 ring-sky-100">
                <h3 className="text-sm font-bold text-sky-900 uppercase tracking-wide mb-2">Diagnóstico</h3>
                <p className="text-sm text-slate-800 leading-relaxed">{demoDocument.impresion}</p>
              </div>
              <div className="rounded-xl border-2 border-amber-200 bg-amber-50/80 p-4 ring-1 ring-amber-100">
                <h3 className="text-sm font-bold text-amber-900 uppercase tracking-wide mb-2">Riesgos</h3>
                <ul className="list-disc pl-5 space-y-1 text-sm text-slate-800">
                  {demoDocument.hallazgos.map((h) => (
                    <li key={h}>{h}</li>
                  ))}
                </ul>
              </div>
              <div className="rounded-xl border-2 border-emerald-200 bg-emerald-50/80 p-4 ring-1 ring-emerald-100">
                <h3 className="text-sm font-bold text-emerald-900 uppercase tracking-wide mb-2">Plan</h3>
                <ul className="list-disc pl-5 space-y-1 text-sm text-slate-800">
                  {demoDocument.plan.map((p) => (
                    <li key={p}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="space-y-3">
          <div className="flex flex-col sm:flex-row sm:justify-end gap-2">
            <Button asChild className="w-full sm:w-auto h-11 bg-slate-800 hover:bg-slate-700 order-1 sm:order-none">
              <Link to="/login">Probar gratis 14 días</Link>
            </Button>
            <Button asChild variant="outline" className="w-full sm:w-auto h-11 border-slate-300 text-slate-800 hover:bg-slate-50 order-2 sm:order-none">
              <Link to="/login">Crear cuenta</Link>
            </Button>
          </div>
          <p className="text-xs text-slate-500 text-center sm:text-right">Sin tarjeta. Acceso inmediato.</p>
        </div>
      </div>
    </div>
  );
}
